import { handleResponse, handleError, headerset } from "./apiUtils";
import {
	User,
	UtenteLogged,
	ChangePasswordProps,
	ResetPasswordProps,
} from "../components/authentication/authenticationSlice";

const baseUrl = process.env.API_URL + "/api/";

export function userCreate() {
	// return fetch(baseUrl).then(handleResponse).catch(handleError);
}

// / ✅ NUOVO: Helper per verificare se token è scaduto
export function isTokenExpired(token: string): boolean {
    try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        const currentTime = Date.now() / 1000;
        return payload.exp < currentTime;
    } catch {
        return true; // Se non riesco a decodificare, considero scaduto
    }
}

// ✅ NUOVO: Helper per ottenere tempo rimanente del token in minuti
export function getTokenRemainingMinutes(token: string): number {
    try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        const currentTime = Date.now() / 1000;
        const remainingSeconds = payload.exp - currentTime;
        return Math.max(0, Math.floor(remainingSeconds / 60));
    } catch {
        return 0;
    }
}

export function tokenObtain(user: User) {
	return fetch(baseUrl + "token/obtain/", {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
			Accept: "application/json",
		},
		body: JSON.stringify({
			username: user.username,
			password: user.password,
		}),
	})
		.then(handleResponse)
		.catch(handleError);
}

import store from "../redux/store";

function getAccessToken(): string | undefined {
    const state = store.getState();
    return state.userPreferenceState.userStored?.access;
}

function getRefreshToken(): string | undefined {
    const state = store.getState();
    return state.userPreferenceState.userStored?.refresh;
}

// ✅ NUOVO: Controllo se refresh token è ancora valido
function isRefreshTokenValid(): boolean {
    const state = store.getState();
    const userStored = state.userPreferenceState.userStored;

    if (!userStored?.refresh || !userStored?.refreshExpiresAt) {
        return false;
    }

    return new Date(userStored.refreshExpiresAt) > new Date();
}

export function tokenRefresh() {
    // ✅ NUOVO: controllo preventivo validità refresh token
    if (!isRefreshTokenValid()) {
        throw new Error("Refresh token expired or invalid");
    }

    return fetch(baseUrl + "token/refresh/", {
        method: "POST",
        headers: {
            Authorization: "JWT " + getAccessToken(),
            "Content-Type": "application/json",
            Accept: "application/json",
        },
        body: JSON.stringify({
            refresh: getRefreshToken(),
        }),
    })
        .then(handleResponse)
        .catch(handleError);
}

export function getUtente() {
	return fetch(baseUrl + "me/", {
		method: "GET",
		headers: {
			"Content-Type": "application/json",
			Accept: "application/json",
			Authorization: headerset().Authorization,
		},
	})
		.then(handleResponse)
		.catch(handleError);
}
// ✅ NUOVO: Funzione per validare la sessione corrente
export function validateCurrentSession() {
    const accessToken = getAccessToken();
    const refreshToken = getRefreshToken();

    if (!accessToken || !refreshToken) {
        return { valid: false, reason: "Missing tokens" };
    }

    if (isTokenExpired(accessToken)) {
        if (isRefreshTokenValid()) {
            return { valid: true, needsRefresh: true };
        } else {
            return { valid: false, reason: "Both tokens expired" };
        }
    }

    return { valid: true, needsRefresh: false };
}

export function saveUser(utente: UtenteLogged) {
	return fetch(baseUrl + "me/", {
		method: "PUT",
		headers: {
			"Content-Type": "application/json",
			Accept: "application/json",
			Authorization: headerset().Authorization,
		},
		body: JSON.stringify({
			...utente,
			// Parse authorId to a number (in case it was sent as a string).
			// id: parseInt(progetto.id, 10),
		}),
	})
		.then(handleResponse)
		.catch(handleError);
}

export function changePassword(passwordStack: ChangePasswordProps) {
	return fetch(baseUrl + "me/change_password", {
		method: "PUT",
		headers: {
			"Content-Type": "application/json",
			Accept: "application/json",
			Authorization: headerset().Authorization,
		},
		body: JSON.stringify({
			...passwordStack,
			// Parse authorId to a number (in case it was sent as a string).
			// id: parseInt(progetto.id, 10),
		}),
	})
		.then(handleResponse)
		.catch(handleError);
}

export function requestPasswordResetEmail(email: string) {
	return fetch(baseUrl + "request-password-reset/", {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
			Accept: "application/json",
			// Authorization: headerset().Authorization,
		},
		body: JSON.stringify({
			email: email,
			// Parse authorId to a number (in case it was sent as a string).
			// id: parseInt(progetto.id, 10),
		}),
	})
		.then(handleResponse)
		.catch(handleError);
}

export function passwordReset({
	uidb64,
	token,
	new_password,
	new_password2,
}: ResetPasswordProps) {
	return fetch(baseUrl + "password-reset/" + uidb64 + "/" + token + "/", {
		method: "PUT",
		headers: {
			"Content-Type": "application/json",
			Accept: "application/json",
			// Authorization: headerset().Authorization,
		},
		body: JSON.stringify({
			new_password: new_password,
			new_password2: new_password2,
			// Parse authorId to a number (in case it was sent as a string).
			// id: parseInt(progetto.id, 10),
		}),
	})
		.then(handleResponse)
		.catch(handleError);
}

export function passwordResetCheck({
	uidb64,
	token,
}: ResetPasswordProps) {
	return fetch(baseUrl + "password-reset/" + uidb64 + "/" + token + "/", {
		method: "GET",
		headers: {
			"Content-Type": "application/json",
			Accept: "application/json",
			// Authorization: headerset().Authorization,
		},
	})
		.then(handleResponse)
		.catch(handleError);
}
